<form class="navbar-form" autocomplete="off">
	<div class="row">
		<div class="col-md-2 mt-3 mb-md-0 mb-3" *ngIf="!nonstock">
			<a [routerLink]="'/vendors/create'" mat-stroked-button color="danger">New Vendor</a>
		</div>
		<div class="col-md-2 mb-md-0 mb-3 mr-auto ml-0" *ngIf="showIncludeInactiveToggle">
			<mat-slide-toggle [formControl]="disabled">Include inactive</mat-slide-toggle>
		</div>
		<div class="ml-auto mr-0 mt-1 mb-0" [ngClass]="(nonstock && !showIncludeInactiveToggle) ? 'col-md-12' : (nonstock ? 'col-md-10' : 'col-md-6')">
			<mat-form-field appearance="outline" class="smaller-font-form">
				<span matPrefix *ngIf="allResults.length && !sending">
					<button mat-icon-button class="p-0" (click)="clearForm()">
						<mat-icon class="p-0">clear</mat-icon>
					</button>
				</span>
				<mat-spinner matPrefix diameter="30" *ngIf="sending"></mat-spinner>
				<input matInput #vendorsearch type="text" (input)="ready=false;" autocomplete="off" [formControl]="vendorSearch" placeholder="Search by Vendor# / Name / Phone..." (keydown)="onSearchKeydown($event)" (keyUpCheck)="filterVendors()" appWaitType autofocus>
				<span matSuffix>
					<button mat-icon-button color="white" type="submit" (click)="filterVendors()">
						<mat-icon class="p-0">search</mat-icon>
					</button>
				</span>
			</mat-form-field>
		</div>
	</div>
</form>

<div class="table" *ngIf="allResults" #resultsWrapper class="vendor-lookup-results">
	<ng-container *ngIf="!allResults?.length && ready">
		<h3 class="text-center">No Results For {{vendorSearch.value}}</h3>
	</ng-container>
	<mat-table [dataSource]="filteredItems" matSort (matSortChange)="announceSortChange($event)" [ngClass]="!allResults.length ? 'd-none' : ''">
		<ng-container matColumnDef="actions">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell"></mat-header-cell>
			<mat-cell *matCellDef="let vendor" class="body-cell">
				<button mat-stroked-button tabindex="-1">View <span [innerHTML]="vendor.supplierid | highlight:vendorSearch.value"></span></button>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="supplierid">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Vendor#</mat-header-cell>
			<mat-cell *matCellDef="let vendor" class="body-cell">
				<span [innerHTML]="vendor.supplierid | highlight:vendorSearch.value"></span>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="suppname">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Name</mat-header-cell>
			<mat-cell *matCellDef="let vendor" class="body-cell">
				<p class="mat-body-1" [innerHTML]="vendor.suppname | highlight:vendorSearch.value"></p>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="address1">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Address</mat-header-cell>
			<mat-cell *matCellDef="let vendor" class="body-cell">
				<p class="billing-address" [innerHTML]="vendor.address1 | highlight:vendorSearch.value"></p>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="telephone">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">Phone#</mat-header-cell>
			<mat-cell *matCellDef="let vendor" class="body-cell">
				<p class="billing-address" [innerHTML]="vendor.telephone | highlight:vendorSearch.value"></p>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="address4">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="header-cell">City</mat-header-cell>
			<mat-cell *matCellDef="let vendor" class="body-cell">
				<p class="billing-address" [innerHTML]="vendor.address4 | highlight:vendorSearch.value"></p>
			</mat-cell>
		</ng-container>
		<mat-header-row *matHeaderRowDef="headercolumns" class="header-row"></mat-header-row>
		<mat-row *matRowDef="let row; columns: headercolumns; let i = index" (click)="selectVendor(row)" class="body-row" [class.vendor-lookup-row-highlight]="i === highlightedRowIndex"></mat-row>
	</mat-table>
	<mat-paginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons aria-label="select page" class="mat-paginator" [ngClass]="!allResults.length ? 'd-none' : ''"></mat-paginator>
</div>

<div class="table table-responsive text-center" *ngIf="!ready && searching">
	<svg class="spinner" width="55px" height="55px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
		<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
	</svg>
</div>
